import React from 'react'

const MARKER = /@@(\d+)@@/

export default function highlightTranslation(translate, key, highlights, className, options = {}) {
  const names = Object.keys(highlights)
  const markers = Object.fromEntries(names.map((name, index) => [name, `@@${index}@@`]))

  return translate(key, { ...options, ...markers }).split(MARKER).map((part, index) => {
    if (index % 2 === 0) return part

    const name = names[Number(part)]
    return <span key={name} className={className}>{highlights[name]}</span>
  })
}
